import breakpoints from '@breakpoints';

// Určení zařízení dle šířky viewportu
export const isDesktop = (): boolean => {
  const DESKTOP_BREAKPOINT = breakpoints.galleryAdvertisement;

  return window.innerWidth > DESKTOP_BREAKPOINT;
};
